import * as lexActionType from '../actionsType/lexExam.actionType';

export const initialState = {
    initUrl: '',
    backendStatus: '',
    backendMsg: '',
    regId: ''
};

export function lexExamReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.INIT_KRY_PREREQUISITE_SUCCESS:
            return {...state, ...action.payload};
        case lexActionType.INIT_KRY_PREREQUISITE_FAILED:
            return {...state, ...action.payload};
        case lexActionType.LEX_EXAM_DOWNLOAD_CERT_SUCCESS:
            return {...state, ...action.payload};
        case lexActionType.LEX_EXAM_DOWNLOAD_CERT_FAILED:
            return {...state, ...action.payload};
        case lexActionType.LEX_EXAM_RESET_STATUS:
            return {...state, ...action.payload};
        default:
            return state;
    }
}
